<template>
	<div class="allMenu">
		<!-- TODO: enable once we can send email
		<div class="allPpop">
			<div class="menuContextualIconoEnvelope" >

				<div class="popUpContact popUpInvisible">
					<div class="contenidoPop">
						<h1>contact us</h1>
						<form action="" method="get" name="myForm">
								<input class="campo" type="text" name="fname" placeholder="Name*"><br>
								<input class="campo" type="email" name="email" placeholder="Email*"><br>
								<textarea rows="6" cols="19" name="description">Message*</textarea><br>
								<div class="btnSend">
										<a class="envioMail" href="#">send</a>
								</div>
								<div class="pico">
									<img src="../assets/img/menu/pico.png" alt="">
								</div>
						</form>
					</div>
				</div>

				<a class="triggerPopUp" @click="popUp" v-if="!anchoNecesarioHamburger">
					<img src="../assets/img/black-envelope.png">
				</a>
				<back-to-top bottom="5px" right="5px" visibleoffset="500">
					<button type="button" class="btn btn-info btn-to-top"><i class="fa fa-chevron-up"></i></button>
				</back-to-top>
			</div>
			<div class="fantasma popUpInvisible" @click="closeFromFantasma">
					--Pop up--
			</div>
		</div> -- allPpop --
		-->

		<div class="wrapper">
				<header>

				<nav>
					<div class="menu-icon" @click="funcionamientoMenuHamburger">
						<i class="fa fa-bars fa-2x transparente"> </i>
						<div class="icon">
							<div class="hamburger" :class="{ activado: menuHamburger}" ></div>
						</div>
					</div>

					<div class="logo">
						<router-link class="logLink aNavbarLogo" to="/"></router-link>
					</div>

					<div class="first_menu " >
						<ul>
							<li><router-link class="aNavbar" to="/"><a :class="{ hereWeAre: areWeinHome  }">Home</a></router-link></li>
							<!-- <li><router-link class="aNavbar" to="/about"><a :class="{ hereWeAre: areWeinAbout  }" >About Us</a></router-link></li> -->
							<li><a href="#" class="services aNavbar" :class="{ hereWeAre: areWeinServices  }" >Services</a>
								<ul class="submenu">
									<div class="fila" v-for="(item, idx) in menuItems" :key="idx">
										<div class="bullet" :class="{bulletSeleccionado: item.route === selectedRoute}"></div>
										<div class="link" :class="{linkSeleccionado: item.route === selectedRoute}">
											<router-link tag="li" :to="{name: item.route}" active-class="active"><a :class="{ fuenteBold: item.route === selectedRoute }" >{{item.label}} </a></router-link>
										</div>
									</div>

								</ul> <!-- submenu -->

							</li>
							<li><router-link class="aNavbar" to="/contact"><a :class="{ hereWeAre: areWeinContact  }">Contact Us</a></router-link></li>
						</ul>
					</div> <!-- first_menu -->

						<div class="movil_menu"	v-if="anchoNecesarioHamburger && menuHamburger">
							<ul>
								<li :class="{ hereWeAre: areWeinHome }"><router-link class="aNavbar" to="/" ><a >Home</a></router-link></li>
								<!-- <li :class="{ hereWeAre: areWeinAbout }" ><router-link class="aNavbar" to="/about"><a >About<span>Us</span></a> </router-link></li> -->
								<li :class="{ hereWeAre: areWeinServices }" ><a class="services " @click="sub = !sub" >Services
										<span class="serviSpan">
											<a href="#" class="fa fa-chevron-down"></a>
										</span>
									</a>
									<div class="submenuEscondidoDiv">
										<ul class="submenu" v-if="sub">
											<router-link v-for="item in menuItems" tag="li" class="subA" :key="item.label" :to="{name: item.route}"><a>{{item.label}}</a></router-link>
										</ul>
									</div>
								</li>
								<li :class="{ hereWeAre: areWeinContact  }" ><router-link class="aNavbar" to="/contact"><a >Contact Us</a> </router-link></li>
							</ul>
					</div>

				</nav>

			</header>

		</div> <!-- wrapper -->

	</div>

</template>

<script>
import JQuery from 'jquery'
var $ = JQuery
import menuItems from "@/components/menu-items.js";
import BackToTop from "vue-backtotop";

import logoAzul from "../assets/img/logos/logo_glarus_blue.png";
import logoBlanco from "../assets/img/logos/logo_glarus_white.png";

export default {
	name: "MenuComponent",
	data: function() {
		return {
			popUpIs: false,
			valor: false,
			offSet: 0,
			menuHamburger: false,
			anchoNecesarioHamburger: false,
			sub: false, // el boton esta en la lina 74
			menuItems: menuItems,
		};
	},
	props: [
		"areWeinServices",
		"areWeinAbout",
		"areWeinHome",
		"areWeinContact",
		"selectedRoute"
	],

	components: {
		BackToTop
	},
	mounted() {
		this.$nextTick(() => {
			// Menu-toggle button

			window.addEventListener("resize", this.detectarOffset);
			//Init
			this.detectarOffset();

			$(document).ready(function() {
				$(".menu-icon").on("click", function() {});
			});
		});
	},
	methods: {
		popUp: function() {
			//console.log("se ha hecho click");
			this.popUpIs = !this.popUpIs;
			if (this.popUpIs) {
				$(".popUpContact").fadeIn("slow");
				$(".fantasma").show();
			} else {
				$(".popUpContact").fadeOut("slow");
				$(".fantasma").hide();
			}
		},

		closeFromFantasma: function() {
			$(".popUpContact").fadeOut("slow");
			$(".fantasma").hide();
			this.popUpIs = !this.popUpIs;
		},

		detectarOffset: function() {
			this.offSet = $("nav").offset().top;
			let anchoPagina = $(window).width();

			if (this.offSet < 500) {
				//$(".popUpContact").css("right", "0px");
				$(".menuContextualIconoEnvelope").css("right", "5px");
			} else {
				//$(".popUpContact").css("right", "60px");
				$(".menuContextualIconoEnvelope").css("right", "60px");
			}

			if (anchoPagina < 860) {
				this.anchoNecesarioHamburger = true;
			} else {
				this.anchoNecesarioHamburger = false;
			}

			if (anchoPagina >= 860 && this.offSet < 100) {
				this.sinScroll();
			} else if (anchoPagina >= 860 && this.offSet > 100) {
				this.conScroll();
			} else if (anchoPagina <= 859) {
				$(".logo").css("background-image", "url(" + logoAzul + ")");
			}
		},
		sinScroll: function() {
			$(".logo").css("background-image", "url(" + logoBlanco + ")");
			$("nav").css(
				"background-color",
				"rgba(249, 249, 249,0)",
				"height",
				"60px"
			);
			$("nav").removeClass("conStroke");

			$(".aNavbar a").css("color", "white");
			$(".aNavbar ").css("color", "white");
			$(".aNavbar").addClass("colorUnderlineLanding");
			$(".aNavbar").removeClass("colorUnderLineAzul");
		},
		conScroll: function() {
			$(".logo").css("background-image", "url(" + logoAzul + ")");
			$("nav").css(
				"background-color",
				"rgba(255, 255, 255, 1)",
				"height",
				"40px"
			);
			$("nav").addClass("conStroke");

			$(".aNavbar a").css("color", "#003b57");
			$(".aNavbar ").css("color", "#003b57");
			$(".aNavbar").addClass("colorUnderLineAzul");
			$(".aNavbar").removeClass("colorUnderlineLanding");
		},
		funcionamientoMenuHamburger: function() {
			this.menuHamburger = !this.menuHamburger;
			//console.count("menuHamburger es " + this.menuHamburger);
		}
	},
	created: function() {
		window.addEventListener("scroll", this.detectarOffset);
	},
	destroyed: function() {
		window.removeEventListener("scroll", this.handleScroll);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.detectarOffset);
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import url("../assets/less/soloVariables.less");
//@import url('../assets/less/medias.less');
@limiteAnchoResponsivo: 860px;

.showing {
	display: block;
}

.white {
	background-color: rgb(255, 255, 255);
}

// Animación de menu
.aNavbar {
	text-decoration: none;
	position: relative;
	//color: @color_Principal_Logo;
}

.linkBlancos {
	color: white;
}
.linkNegros {
	color: black;
}

.colorUnderlineLanding:after {
	border-bottom: 2px solid white;
}

.colorUnderLineAzul:after {
	border-bottom: 2px solid @color_Principal_Logo;
}

.aNavbar:after {
	content: "";
	position: absolute;
	top: 25px;
	left: 0px;
	width: 0%;
	//border-bottom: 2px solid white;
	transition: 0.4s;
}

.aNavbar:hover:after {
	width: 100%;
}

.primero:hover:after {
	width: 47%;
}
//

//Navbar fin

.content {
	top: 200px;
	width: 94%;
	margin: 4em auto;
	font-size: 20px;
	line-height: 30px;
	text-align: justify;
}

.wrapper {
	header {
		width: 100%;

		background-size: cover;

		nav.conStroke {
			border-bottom: 1px solid #648175;
		}

		nav {
			position: fixed;
			top: 0px;
			width: 100%;
			z-index: 50;

			transition: all 0.4s ease-in;
			@media (max-width: @limiteAnchoResponsivo) {
				position: absolute;
				height: 30px;
			}
			@media @mobile {
				position: relative;
			}

			.menu-icon {
				position: relative;
				line-height: 60px;
				width: 100%;

				text-align: right;
				box-sizing: border-box;
				padding: 15px 24px;
				cursor: pointer;

				color: rgb(161, 20, 20);

				background: rgba(255, 255, 255, 0);
				display: none;
				transition: all 0.4s ease-in;

				.icon {
					position: absolute;
					top: 5%;
					right: 1%;
					transform: translate(50% 50%);
					width: 70px;
					height: 60px;
					cursor: pointer;
					//border: 1px solid red;

					.hamburger {
						width: 25px;
						height: 4px;
						background: @color_Principal_Logo;
						position: absolute;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);
						box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
						transition: 0.5s;
						&:before,
						&:after {
							content: "";
							transform: translate(-100%, 25%);
							position: absolute;
							width: 25px;
							height: 4px;
							background: @color_Principal_Logo;
							box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
							transition: 0.5s;
						}
						&:before {
							top: -10px;
						}
						&:after {
							top: 9px;
						}

						&.activado {
							background: rgba(0, 0, 0, 0);
							transform: translate(-150%, 25%);
							box-shadow: 0 2px 5px rgba(0, 0, 0, 0);
						}
						&.activado:before {
							top: 0;
							
							transform: rotate(45deg);
							
						}
						&.activado:after {
							top: 0;
							transform: rotate(135deg);
						}
					}
				}

				@media (max-width: @limiteAnchoResponsivo) {
					padding: 5px 0px;
					background: rgba(250, 250, 250, 1);
					display: block;
				}

				@media @mobile {
					padding: 5px 0px;
				}

				.transparente {
					background: rgba(0, 0, 0, 0);
					color: rgba(0, 0, 0, 0);
				}
			}
			.logo {
				line-height: 60px;
				position: fixed;
				float: left;
				margin: 16px 26px;
				//color: #fff;
				font-weight: bold;
				font-size: 20px;
				letter-spacing: 2px;

				width: 250px;
				height: 60px;

				//background: url(../assets/img/logos/logo_glarus_white.png) no-repeat 50% 50%;
				background-size: cover;
				@media @mobile, (max-width: @limiteAnchoResponsivo) {
					position: absolute;
					margin: 0;
					top: 0px;
				}
				.logLink {
					display: block;
					width: 100%;
					height: 100%;
					//background: yellow;
				}
				@media (max-width: @limiteAnchoResponsivo) {
					margin: 4px 26px;
					background: url(../assets/img/logos/logo_glarus_blue.png) no-repeat 50% 50%;
					background-size: cover;
				}
				@media @mobile {
					background-size: 90%;
					background-position: 0% 50%;
				}
			} // logo



			//Menu que no es movil
			.first_menu {
				padding-right: 20px;

				@media (max-width: @limiteAnchoResponsivo) {
					position: relative;
					top: 60px;
					display: none;
				}

				ul {
					.hereWeAre {
						font-weight: 700;
						background: url("../assets/img/menu/bullet.png") no-repeat left top;
						padding-left: 15px;
					}

					.services {
						cursor: pointer;
					}
					.serviSpan {
						font-size: 0.3em;
						opacity: 0;
						position: relative;
						//display: none;
					}
					@media (max-width: @limiteAnchoResponsivo) {
						.serviSpan {
							//display: block;
							font-size: 0.8em;
							opacity: 1;
							position: absolute;
							right: 10px;

							a {
								padding: 15px;
							}
						}
					}
					span {
						padding-left: 8px;
					}
					line-height: 60px;
					list-style: none;
					background: rgba(0, 0, 0, 0);
					overflow: hidden;
					//color: #fff;
					padding: 0;
					text-align: right;
					margin: 0;
					padding-right: 30px;
					transition: 1s;

					@media (max-width: @limiteAnchoResponsivo) {
						background-color: white;
						padding-right: 0px;
					}

					.router-link-exact-active {
					}

					.active {
						//font-weight: bolder;
						//margin: 10px 0px;
						//padding-bottom: 20px;
						//background: url('../assets/img/menu/bullet_verde.png') no-repeat left top;
						//border: 1px solid red;
					}

					li {
						display: inline-block;
						padding: 16px 30px;
						//height: 90%;

						&:hover ul {
							display: block;
						}
						@media (max-width: @limiteAnchoResponsivo) {
							display: block;
							//height: 100px;
							padding: 0px;
							font-size: 0.4em;
							text-align: left;
							border-top: 0.3px solid #003b57;
							&:hover ul {
								//En movil no aparece en roll over
								display: none;
							}
							&:hover {
								background-color: rgb(240, 238, 238);
							}
						}

						a {
							text-decoration: none;
							color: #eff2f3;
							font-size: 14px;
							text-transform: uppercase;

							@media (max-width: @limiteAnchoResponsivo) {
								color: #003b57;
								padding-left: 30px;
							}
						}
						.submenu {
							display: flex;
							flex-flow: column;

							position: absolute;
							
							display: none;

							text-align: left;
							
							padding: 10px 0px;
							padding-bottom: 20px;
							width: 280px;
							line-height: 1.2em;
							top: 92px;

							border-top: 2px solid #648175;
							background-color: rgba(5, 50, 84, 1);

							.fila {
								display: flex;
								flex-flow: row;
								//border: 1px solid brown;
								width: 90%;
								padding: 8px 10px;

								.bullet {
									width: 5%;
									padding: 10px;
									background-repeat: no-repeat;
									background-position: center center;
									background-size: 5px 9px;
								}
								.bulletSeleccionado {
									background-image: url(../assets/img/menu/bullet_verde.png);
								}

								.link {
									width: 80%;
									color: white;
									.fuenteBold{
											font-weight: 500;
										}
								}
								.linkSelecionado {
									font-size: 1rem;
								}
							}

							@media (max-width: @limiteAnchoResponsivo) {
								//display: block;
								position: relative;
								font-size: 3.5em;
								//line-height: 3em;
								text-align: left;
								color: #003b57;
								margin-right: 0px;
								right: 0px;
								width: 100%;
								top: 0px;
								padding-right: 0px;
								padding-bottom: 0px;

								background-color: rgba(136, 54, 54, 0.9);
							}
							li {
								width: 100%;
								padding: 2px 5px;
								//height: 1px;

								@media (max-width: @limiteAnchoResponsivo) {
									line-height: 1.5em;
									width: 100%;
									padding-top: 18px;
									padding-bottom: 18px;
									padding-left: 10px;
									border-top: none;
								}
								a {
									font-size: .8rem;
									line-height: 1.3em;
									font-weight: 200;
									color: lighten(@color_Secundario_Logo, 40);

									@media (max-width: @limiteAnchoResponsivo) {
										font-size: 1.3em;
										padding-top: 8px;
										padding-bottom: 8px;
										color: #242323;
									}
									&:hover {
										color: white;
										font-weight: 500;
										@media (max-width: @limiteAnchoResponsivo) {
											color: #8a8787;
										}
									}
								}
							}
						}
					}
				}
			}

			//Menu Movil
			//@media (max-width: @limiteAnchoResponsivo) {}
			.movil_menu {
				position: relative;
				top: 60px;
				z-index: 100;
				@media (max-width: @limiteAnchoResponsivo) {
					top: 0;
					box-shadow: 20px 20px 50px grey;
				}
				ul {
					font-size: 1em;
					font-weight: bold;
					line-height: 60px;
					list-style: none;
					background: rgba(0, 0, 0, 0.4);
					overflow: hidden;
					//color: #fff;
					padding: 0;
					text-align: right;
					margin: 0;
					padding-right: 0px;
					transition: 1s;

					background-color: white;
					width: 100%;

					.hereWeAre {
						background-color: rgba(4, 61, 114, 0.1);
						//cursor: pointer;
					}

					li {
						//border: 1px solid green;
						.aNavbar {
							text-transform: uppercase;
							span {
								padding-left: 5px;
							}
							a{
								
								padding-left: 0px;
							}
						}

						.services {
							//color: #8a8787;
							text-transform: uppercase;

							//border: 1px solid red;

							//Icono arrow down

							.serviSpan {
								font-size: 0.8em;
								opacity: 1;
								position: absolute;
								right: 15px;

								a {
									font-weight: bolder;
									//color: red;

									border-radius: 50%;
									transition: all 0.3s ease-out;
									&:hover {
										font-size: 2em;
									}
								}
							}
						}
					}

					.submenuEscondidoDiv {
						.submenu {
							li {
								background-color: rgba(240, 238, 238, 0.5);
								&.router-link-active,
								router-link-exact-active {
									background-color: rgba(4, 61, 114, 0.25);
									cursor: pointer;
								}
								&:hover {
									background-color: rgba(255, 255, 255, 0.8);
								}
								.subA {
									padding-left: 60px;
									
								}
								.menuMovil{
									color: red;
								}

								a {
									font-size: 0.9em;
									
								}
							}
						}
					}

					li {
						display: inline-block;
						padding: 16px 30px;
						//height: 100%;
						//border: 1px solid red;

						display: block;
						//height: 100px;
						padding: 0px;
						//font-size: 0.4em;
						text-align: left;
						border-top: 0.3px solid #003b57;

						&:hover {
							background-color: rgb(240, 238, 238);
						}

						a {
							text-decoration: none;
							color: #eff2f3;
							//font-size: 14px;

							color: #003b57;
							padding-left: 30px;
						}
					}
				}
			}
		}
	}
}

//PopUp

// back to top
.btn-to-top {
	width: 50px;
	height: 50px;
	padding: 10px 10px;
	//border-radius: 50%;
	font-size: 22px;
	line-height: 22px;
}
.btn-info {
	color: white;
	background-color: rgba(0, 0, 0, 0.5);
}
///

.allPpop {
	//display: flex;
	//padding: 15px;

	.fantasma {
		position: fixed;
		width: 100%;
		height: 100%;
		z-index: 65;
		//background-color: @gradiente_mascara_color;
	}

	.menuContextualIconoEnvelope {
		z-index: 66;
		position: fixed;
		bottom: 15px;
		right: 5px;

		.triggerPopUp {
			background-color: lighten(@gradiente_mascara_color, 5);
			padding: 20px 10px 10px 10px;

			text-decoration: none;
			transition: background-color 0.3s ease;
			cursor: pointer;
			@media @tablet {
				display: none;
			}

			img {
				width: 30px;
			}
		}
		.triggerPopUp:hover {
			background-color: darken(@gradiente_mascara_color, 15);
		}
	}

	.menuContextualIconoEnvelope {
		.popUpContact {
			position: absolute;
			right: 0px;
			top: -430px;
			background-color: @gris_popUp_form;
			box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
				0 6px 20px 0 rgba(0, 0, 0, 0.19);
			width: 230px;
			height: 368px;
			padding: 20px;
			z-index: 66;

			.pico {
				display: flex;
				flex-flow: row;
				width: 100%;
				justify-content: flex-end;
				padding-top: 10px;
			}

			h1 {
				font-size: 0.8em;
				text-align: center;
				color: darken(@gris_popUp_form, 35);
				text-transform: uppercase;
				padding: 8px 0px 15px 0px;
				font-family: @fuente_principal;
			}
			input {
				width: 85%;
				padding: 15px;
				margin: 3px 0px 10px 0px;
				font-size: 0.9em;
				border-style: none;
				color: darken(@gris_popUp_form, 20);
				font-family: @fuente_principal;
			}
			textarea {
				padding: 15px;
				margin-bottom: 10px;
				resize: none;
				width: 85%;
				border-style: none;
				color: darken(@gris_popUp_form, 30);
				font-family: @fuente_principal;
			}
			.btnSend {
				display: flex;
				justify-content: flex-start;
				align-items: center;
				align-content: center;
				flex-direction: column;
				a {
					padding: 9px 25px 9px 25px;
					background-color: @color_Principal_Logo;
					text-transform: uppercase;
					font-size: 0.8em;
					color: white;
				}
				a:hover {
					background-color: darken(@color_Principal_Logo, 5);
				}
			}
		}
	}
}

.popUpVisible {
	display: block;
}
.popUpInvisible {
	display: none;
}
</style>
